export const darkTheme = {
  bg: "#050507",
  bgAlt: "#08080c",
  card: "rgba(255, 255, 255, 0.035)",
  card_light: "rgba(255, 255, 255, 0.06)",
  card_border: "rgba(255, 255, 255, 0.09)",
  primary: "#8B7CFF",
  secondary: "#22D3EE",
  gradient: "linear-gradient(120deg, #8B7CFF 0%, #22D3EE 100%)",
  text_primary: "#F5F5F8",
  text_secondary: "#9A9CAE",
  text_muted: "#65667a",
  white: "#FFFFFF",
  black: "#000000",
  success: "#34D399",
};

// Kept for API compatibility. The site renders dark-mode only by design.
export const lightTheme = darkTheme;
